// extracted by mini-css-extract-plugin
export default {"title":"B5-z","warning":"C5-z","sizeOptionsLegendText":"D5-z"};